import React from 'react';
import { S12Reviews, S12ReviewsProps, MilanGradientColors, MilanBackgroundColors } from '@milanlaser/mlcomponents';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';
import { processBackgroundAndGradientColorMap } from '../../utils/builder.utils';

interface S12ReviewsArgs
    extends Omit<S12ReviewsProps, 'backgroundGradient' | 'cardBackgroundGradient' | 'backgroundColor'> {
    desktopPaddingTop: PaddingSize;
    desktopPaddingBottom: PaddingSize;
    mobilePaddingTop: PaddingSize;
    mobilePaddingBottom: PaddingSize;
    backgroundGradient: MilanGradientColors | 'None';
    cardBackgroundGradient?: MilanGradientColors | 'None';
    backgroundColor?: string;
}

export function S12ReviewsSection(s12Props: S12ReviewsArgs) {
    const {
        desktopPaddingTop,
        desktopPaddingBottom,
        mobilePaddingTop,
        mobilePaddingBottom,
        backgroundGradient,
        cardBackgroundGradient,
        backgroundColor,
        ...restProps
    } = s12Props;

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

    const processedBackgroundGradient = backgroundGradient === 'None' ? '' : backgroundGradient;
    const processedCardBackgroundGradient = cardBackgroundGradient === 'None' ? '' : cardBackgroundGradient;
    const processedBackgroundColor = backgroundColor === 'None' ? '' : backgroundColor;

    const modifiedProps = {
        ...restProps,
        className: `mcl-mx-auto mcl-max-w-7xl ${topPaddingClasses} ${bottomPaddingClasses} [&_p]:mb-0`,
        backgroundColor: processedBackgroundColor as MilanBackgroundColors,
        backgroundGradient: processedBackgroundGradient as MilanGradientColors,
        cardBackgroundGradient: processedCardBackgroundGradient as MilanGradientColors,
    };

    const backgroundColorClass = processBackgroundAndGradientColorMap({
        backgroundColor: (processedBackgroundColor || 'None') as MilanBackgroundColors | 'None',
        gradientColor: (processedBackgroundGradient || 'None') as MilanGradientColors | 'None',
    });

    return (
        <div className={`${backgroundColorClass}`}>
            <S12Reviews {...modifiedProps} />
        </div>
    );
}
